import styled from 'styled-components/macro';
import OtpField from 'react-otp-input';
import { COLORS } from 'utils/styles/colors';
import { Link } from 'react-router-dom';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const ForgotPasswordWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};
  position: relative;
`;

export const ForgotPasswordBlock = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow};
  width: 450px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  margin-top: 160px;
  margin-bottom: 100px;

  @media only screen and ${deviceMax.desktop} {
    width: 400px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 290px;
  }
`;

export const Form = styled.form`
  padding: 20px;
  margin-bottom: 150px;
`;

export const PageTitle = styled.div`
  ${FONTS.font24}
  ${FONT_FAMILY.FontBold}
  text-align: center;
  margin-top: 20px;
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.tablet} {
    ${FONTS.font20}
  }
`;

export const CloseIcon = styled.img`
  @media only screen and ${deviceMax.mobileL} {
    width: 12px;
  }
`;

export const CloseIconLink = styled(Link)`
  position: absolute;
  top: 20px;
  right: 20px;

  @media only screen and ${deviceMax.mobileL} {
    width: 14px;
  }
`;

export const ModalDescription = styled.div`
  ${FONT_FAMILY.FontLight}
  ${FONTS.font16}
  ${FLEX_CONTAINER.FlexRow}
  color: ${COLORS.blueBlack};
  text-align: ${({ isTextLeft }) => (isTextLeft ? 'left' : 'center')};
  padding-left: ${({ isTextLeft }) => (isTextLeft ? '30px' : 'unset')};
  padding-bottom: ${({ isTextLeft }) => (isTextLeft ? '70px' : 'unset')};
  height: 38px;
  text-align: center;
  margin-top: 20px;
  gap: 4px;

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font14}
  }
`;

export const BoldResendText = styled.div`
  ${FONT_FAMILY.FontMedium}
  ${FONTS.font16}
  color: ${COLORS.mainColor};
`;

export const InputBlocksForVerification = styled.div`
  ${FLEX_CONTAINER.FlexCenterRow}
  width: 100%;
  margin-top: 50px;
  
  }
`;

export const OtpFieldWrapper = styled(OtpField)`
  ${FLEX_CONTAINER.FlexRow}

  .otp-field__input {
    width: 50px !important;
    height: 36px;
    ${FLEX_CONTAINER.Unset}
    text-align: center;
    margin: 16px;
    background: none;
    border-bottom: ${({ error }) =>
    error ? `1px solid ${COLORS.red}` : `1px solid ${COLORS.mainColor}`};
    color: ${({ error }) => (error ? `${COLORS.red}` : `${COLORS.black}`)};
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 100%;
    ${FONTS.font14}
    .otp-field__input {
      width: 30px !important;
    }
  }
`;

export const StyledButtonContainer = styled.div`
  margin-top: 30px;
`;

export const ErrorMessage = styled.p`
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font12};
  color: ${COLORS.red};
  padding-bottom: 8px;
  padding-left: 26px;
  height: 14px;
`;
